import React from 'react'
import styled from 'styled-components'
import { squareOrangeButton } from '../../styles/reusable.style'

const StyledAnchorButton = styled.a`
	${({ noStyle }) => (noStyle ? '' : squareOrangeButton())};
`
/**
 *
 * @param {boolean} noStyle
 * Removes styles of button
 *
 * @param {boolean} targetBlank
 * True if needs to open in a new window
 */
const AnchorButton = props => {
	const { targetBlank } = props
	return (
		<StyledAnchorButton
			{...props}
			target={targetBlank ? '_blank' : ''}
			rel={targetBlank ? 'noreferer noopenner' : ''}>
			{props.children}
		</StyledAnchorButton>
	)
}

export default AnchorButton
